// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"2f437816","425":"bca97e58","627":"605d6a52","952":"cf235397"}[chunkId] + ".chunk.css";
};